import { render, staticRenderFns } from "./EditQualificationsAction.vue?vue&type=template&id=5cab3182&scoped=true&"
import script from "./EditQualificationsAction.vue?vue&type=script&lang=js&"
export * from "./EditQualificationsAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cab3182",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
